import { render } from "./WriteMessageButton.vue?vue&type=template&id=304aef46"
import script from "./WriteMessageButton.vue?vue&type=script&lang=js"
export * from "./WriteMessageButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__